// extracted by mini-css-extract-plugin
module.exports = {"whyus":"whyus_whyus__2I6Ua","wrapper":"whyus_wrapper__JUjdV","sectitel":"whyus_sectitel__1y7bP"};